<template>
  <div class="renzh">
    <div class="top-box">
      <div class="flexrbc">
        <div class="flexr0c">
          <div class="title-label"></div>
          <div class="title">矿种售价管理</div>
        </div>
        <div class="addOre flexrcc" @click="addOre">
          <img src="../../assets/imgs/home/add.png" alt />
          <div class="btn">新增矿种</div>
        </div>
      </div>
    </div>
    <div class="search-box flexr0c">
      <div class="input">
        <Input placeholder="请输入需要查询的内容" v-model="keyword" size="large" style="width: auto">
          <Icon type="ios-search" slot="suffix" />
        </Input>
      </div>
      <div class="btn" @click="getPage(1, keyword)">查询</div>
    </div>
    <div class="table-box">
      <div class="table">
        <Table max-height="" :loading="loading1" border stripe :columns="tableHead" :data="tableData">
          <template slot-scope="{ row }" slot="state">
            <div :class="row.state == '在售' ? 'onSell' : 'stopSell'">{{ row.state }}</div>
          </template>
          <template class="flexr0c" slot-scope="{ row, index }" slot="action">
            <div class="flexr0c">
              <div class="edit flexr0c" @click="edit(index)">
                <div class="iconfont">&#xe601;</div>
                <div class="item">编辑</div>
              </div>
              <div class="delete flexr0c" @click="log(index)">
                <div class="iconfont">&#xe602;</div>
                <div class="item">日志</div>
              </div>
            </div>
          </template>
        </Table>
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page :total="total" :current="1" :page-size="pageSize" @on-change="changePage" show-elevator show-total> </Page>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="modal1 || modal2 || modal3">
      <div v-if="modal1" class="pop1-box">
        <div class="top flexrcc">
          <div class="title">编辑</div>
          <img @click="modal1 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content">
          <div class="item flexc0s">
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">矿种名称</div>
            </div>
            <div class="flexr0c">
              <input type="text" disabled :value="tableData[index].oreName" class="name-input" />
            </div>
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">销售价格(元/吨)</div>
            </div>
            <div class="flexr0c">
              <Input v-model="unitPrice1" maxlength="20" type="text" class="price-input" @on-input="value = value.replace(/[^\d]/g, '')" />
              <div class="unit">元/吨</div>
            </div>
            <div v-show="isWaterRatio == 1">
              <div class="title-box flexr0c">
                <span>*</span>
                <div class="title">含水系数(%)</div>
              </div>
              <div class="flexr0c">
                <Input v-model="waterRatio" type="number" class="price-input" @on-input="value = value.replace(/[^\d]/g, '')" />
                <div class="unit">%</div>
              </div>
            </div>
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">销售状态</div>
              <RadioGroup v-model="disabledGroup">
                <Radio label="在售"></Radio>
                <Radio label="停售"></Radio>
              </RadioGroup>
            </div>
            <div class="title-box flexr0c">
              <div class="title">备注</div>
            </div>
            <Input v-model="remark1" type="textarea"></Input>
          </div>
        </div>
        <div class="bottom flexrcc">
          <div class="cancel" @click="cancelModal(1)">取消</div>
          <div class="save" @click="save1">保存</div>
        </div>
      </div>
      <div v-if="modal2" class="pop1-box">
        <div class="top flexrcc">
          <div class="title">新增</div>
          <img @click="modal2 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content">
          <div class="item flexc0s">
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">矿种名称</div>
            </div>
            <Select v-model="select1" style="width: 368px">
              <Option v-for="(item, index) in optionList" :value="item.oreId + '/' + item.oreName" :key="index"> {{ item.oreName }}</Option>
            </Select>
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">销售价格(元/吨)</div>
            </div>
            <div class="flexr0c">
              <Input v-model="unitPrice2" maxlength="20" type="text" class="price-input" @on-input="value = value.replace(/[^\d]/g, '')" />
              <div class="unit">元/吨</div>
            </div>
            <div v-show="isWaterRatio == 1">
              <div class="title-box flexr0c">
                <span>*</span>
                <div class="title">含水系数(%)</div>
              </div>
              <div class="flexr0c">
                <Input v-model="waterRatio" type="number" class="price-input" @on-input="value = value.replace(/[^\d]/g, '')" />
                <div class="unit">%</div>
              </div>
            </div>
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">销售状态</div>
              <RadioGroup v-model="disabledGroup">
                <Radio label="在售"></Radio>
                <Radio label="停售"></Radio>
              </RadioGroup>
            </div>
            <div class="title-box flexr0c">
              <div class="title">备注</div>
            </div>
            <Input v-model="remark2" type="textarea" class="remark"></Input>
          </div>
        </div>
        <div class="bottom flexrcc">
          <div class="cancel" @click="cancelModal(2)">取消</div>
          <div class="save" @click="save2">保存</div>
        </div>
      </div>
      <div v-if="modal3" class="pop3-box">
        <div class="top flexrcc">
          <div class="title">日志</div>
          <img @click="modal3 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content">
          <div class="item">
            <div class="flexrbc">
              <div class="half flexc0s">
                <div class="name">矿种名称</div>
                <input v-model="logName" disabled class="half-input" type="text" name id />
              </div>
              <div class="half flexc0s">
                <div class="name">销售状态</div>
                <input v-model="logState" disabled class="half-input" type="text" name id />
              </div>
            </div>
            <div class="name">备注</div>
            <input v-model="logRemark" disabled type="text" maxlength="50" class="long-input" />
            <hr class="split-line" />
            <div class="flexr0c filter">
              <div class="label">维护日期</div>
              <div class="date-picker">
                <Row>
                  <Col span="12">
                    <DatePicker :value="value2" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 220px" @on-change="setDate"></DatePicker>
                  </Col>
                </Row>
              </div>
              <div class="label">修改项目</div>
              <Select v-model="select2" style="width: 140px" @on-change="getLogInfo">
                <Option v-for="(item, index) in optionList2" :value="item.value" :key="index">{{ item.label }}</Option>
              </Select>
            </div>
            <Table max-height="230" border stripe :columns="logHead" :data="logData"> </Table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { _throttle } from '../../config/utils.js';
export default {
  name: 'sellPrice',
  data() {
    return {
      modal1: false,
      modal2: false,
      modal3: false,
      model1: '',
      modal_loading: false,
      value2: [],
      disabledGroup: '在售',
      keyword: '',
      total: 100,
      unitPrice1: '',
      unitPrice2: '',
      waterRatio: 0,
      isWaterRatio: null,
      remark1: '',
      remark2: '',
      loading1: true,
      pageSize: 8,
      logName: '',
      logState: '',
      logRemark: '',
      tableHead: [
        {
          title: '矿种名称',
          key: 'oreName',
          width: 140,
          resizable: true
        },
        {
          title: '销售状态',
          slot: 'state',
          width: 110,
          resizable: true
        },
        {
          title: '销售价格(元/吨)',
          key: 'orePrice',
          width: 165,
          resizable: true
        },
        {
          title: '含水系数(%)',
          key: 'waterRatio',
          width: 120,
          resizable: true,
          render: (h, params) => {
            return h('span', {}, params.row.waterRatio || 0);
          }
        },
        {
          title: '备注',
          key: 'remark',
          width: 180,
          resizable: true,
          render: (h, params) => {
            if (params.row.remark && params.row.remark.length > 15) {
              return h('div', [
                h(
                  'Tooltip',
                  {
                    props: {
                      transfer: true,
                      theme: 'light'
                    }
                  },
                  [
                    h(
                      'span',
                      {
                        style: {
                          display: 'inline-block',
                          width: params.column._width * 0.9 + 'px',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap'
                        }
                      },
                      params.row.remark
                    ),
                    h(
                      'span',
                      {
                        slot: 'content',
                        style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                      },
                      params.row.remark
                    )
                  ]
                )
              ]);
            } else {
              return h('span', {}, params.row.remark);
            }
          }
        },
        {
          title: '维护人',
          key: 'createUserName',
          width: 180,
          resizable: true
        },
        {
          title: '维护日期',
          key: 'createTime',
          width: 200,
          resizable: true
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'left',
          fixed: 'right',
          resizable: true
        }
      ],
      tableData: [],
      logHead: [
        {
          title: '维护时间',
          key: 'updateTime',
          width: 190,
          resizable: true
        },
        {
          title: '维护人',
          key: 'updateUserName',
          width: 95,
          resizable: true
        },
        {
          title: '修改项目',
          key: 'updateItem',
          width: 115,
          resizable: true
        },
        {
          title: '旧值',
          key: 'oldValue',
          width: 120,
          resizable: true
        },
        {
          title: '新值',
          key: 'newValue',
          // width: 120,
          resizable: true
        }
      ],
      logData: [],
      optionList: [],
      optionList2: [
        {
          value: '全部',
          label: '全部'
        }
      ],
      select1: '',
      select2: '',
      index: -1,
      once: true
    };
  },
  created() {
    this.getPage(1);
    this.getSelect();
  },
  methods: {
    cancelModal(type) {
      if (type == 1) {
        this.modal1 = false;
      } else {
        this.modal2 = false;
      }
      this.isWaterRatio = null;
      this.waterRatio = 0;
    },
    edit(index) {
      this.index = index;
      this.unitPrice1 = this.tableData[this.index].orePrice;
      this.remark1 = this.tableData[this.index].remark;
      this.disabledGroup = this.tableData[this.index].state;
      this.isWaterRatio = this.tableData[this.index].isWaterRatio;
      this.waterRatio = this.tableData[this.index].waterRatio || 0;
      this.modal1 = true;
    },
    log(index) {
      this.index = index;
      this.select2 = '';
      this.value2 = [];
      this.logName = this.tableData[index].oreName;
      this.logState = this.tableData[index].state;
      this.logRemark = this.tableData[index].remark;
      this.getLogInfo();
      setTimeout(() => {
        this.modal3 = true;
      }, 300);
    },
    changePage(page) {
      this.getPage(page, this.keyword);
    },
    setDate(value) {
      this.value2 = value;
      this.getLogInfo();
    },
    save1() {
      if (this.unitPrice1 == '') {
        this.$Message['error']({
          background: true,
          content: '请输入销售价格'
        });
        return;
      }
      if (this.isWaterRatio == 1) {
        if (!this.watchWaterValue()) {
          return;
        }
      }
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'XXWODnpOFiNLgAHcGPZ1Y9H6PhOrL5wq',
        id: this.tableData[this.index].id,
        oreId: this.tableData[this.index].oreId,
        oreName: this.tableData[this.index].oreName,
        orePrice: this.unitPrice1,
        state: this.disabledGroup == '在售' ? 1 : 2,
        remark: this.remark1,
        waterRatio: this.waterRatio
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.modal1 = false;
          this.isWaterRatio = null;
          this.waterRatio = 0;
          this.getPage(1);
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    watchWaterValue() {
      let reg = /^[0-9]+(.[0-9]{1,2})?$/;
      if (Number(this.waterRatio) < 0) {
        this.$Message['error']({
          background: true,
          content: '含水系数最小值为0'
        });
        this.waterRatio = 0;
        return false;
      } else if (Number(this.waterRatio) > 100) {
        this.$Message['error']({
          background: true,
          content: '含水系数最大值为100'
        });
        this.waterRatio = 100;
        return false;
      } else if (!reg.test(Number(this.waterRatio))) {
        return false;
      } else {
        return true;
      }
    },
    save2: _throttle(function() {
      if (this.select1 == '') {
        this.$Message['error']({
          background: true,
          content: '请选择矿种'
        });
        return;
      }
      if (this.unitPrice2 == '') {
        this.$Message['error']({
          background: true,
          content: '请输入销售价格'
        });
        return;
      }
      if (this.isWaterRatio == 1) {
        if (!this.watchWaterValue()) {
          return;
        }
      }
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'xcaY7UBVRg9Zo7snXPPJZtLwPNFJ1Uoi',
        oreId: this.select1.split('/')[0],
        oreName: this.select1.split('/')[1],
        orePrice: this.unitPrice2,
        state: this.disabledGroup == '在售' ? '1' : '2',
        remark: this.remark2,
        waterRatio: this.waterRatio
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.modal2 = false;
          this.waterRatio = 0;
          this.isWaterRatio = null;
          this.getPage(1);
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    }, 5000),
    getSelect() {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        modeCode: '8Nj3MDYFYm6AMtHz8dYeDsMk7bEAC8Cg'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.optionList = res.data;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getPage(index, keyword = '') {
      this.loading1 = true;
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '3IiMh85uwYuMI22A0lK8pzaGPfAnxgxO',
        oreName: keyword,
        pageIndex: index,
        pageSize: this.pageSize
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.total = res.count;
          let list = res.result_ctn;
          list.forEach((item) => {
            item.state == 1 ? (item.state = '在售') : (item.state = '停售');
          });
          this.tableData = list;
          this.loading1 = false;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
          this.loading1 = false;
        }
      });
    },
    getOrgType() {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '8Nj3MDYFYm6AMtHz8dYeDsMk7bEAC8Cg'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          let list = res.result_ctn;
          list.forEach((item) => {
            item.value = item.oreName;
          });
          this.cityList = list;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    addOre() {
      this.select1 = '';
      this.unitPrice2 = '';
      this.remark2 = '';
      this.disabledGroup = '在售';
      this.modal2 = true;
    },
    getLogInfo() {
      var session = JSON.parse(localStorage['session']);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'a8WXxPdFxwjNSyUJ9154kQGmA7wQzing',
        dataId: this.tableData[this.index].id
      };
      if (this.value2 != '') {
        data.startDate = this.value2[0].replace(/\//g, '-');
        data.endDate = this.value2[1].replace(/\//g, '-');
      }
      if (this.select2 != '') {
        this.select2 == '全部' ? (data.updateItem = '') : (data.updateItem = this.select2);
      }
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.total = res.count;
          this.logData = res.data;
          let list = [];
          res.data.forEach((item) => {
            list.push(item.updateItem);
          });
          list = Array.from(new Set(list));
          if (this.once) {
            list.forEach((item) => {
              let obj = {};
              obj.value = item;
              obj.label = item;
              this.optionList2.push(obj);
            });
            this.once = false;
          }
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
      }
      return fmt;
    }
  },
  watch: {
    // 监听新增矿种时的矿种名称
    select1(newVal) {
      if (newVal) {
        const oreId = newVal.split('/')[0];
        const arr = this.optionList.filter((item) => {
          if (item.oreId == oreId) return item;
        });
        const isWater = arr[0].isWaterRatio;
        this.isWaterRatio = isWater;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.renzh {
  width: 980px;
  height: 100%;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #f2f3f5;
  position: relative;

  .top-box {
    background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
    border-radius: 10px 10px 0 0;
    width: 100%;
    height: 40px;

    & > div {
      height: 100%;
      width: 928px;
      margin: 0 auto;
    }

    .title-label {
      width: 4px;
      height: 14px;
      background: #2c59c3;
    }

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #2c59c3;
      letter-spacing: 0.4px;
      margin-left: 6px;
    }

    .addOre {
      background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
      border: 1px solid #4c9b25;
      border-radius: 6px;
      width: 110px;
      height: 30px;
      cursor: pointer;

      &:hover {
        background-image: linear-gradient(180deg, #c4ff5b 0%, #4aa824 100%);
      }

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }

      .btn {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
      }
    }
  }

  .search-box {
    height: 74px;
    background-color: #f2f3f5;

    .input {
      margin: 0 10px 0 26px;
    }

    .btn {
      background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
      border: 1px solid #006bc4;
      border-radius: 6px;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0.35px;
      cursor: pointer;

      &:hover {
        background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
      }
    }
  }

  .table-box {
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    border-radius: 10px;
    min-height: 534px;
    overflow: hidden;

    .table {
      width: 928px;
      margin: 25px auto;

      .delete {
        margin-left: 14px;
      }

      .edit,
      .delete {
        color: #4a4a4a;
      }

      .edit:hover,
      .delete:hover {
        color: #4a90e2 !important;
        cursor: pointer;
      }

      .item {
        margin-left: 4px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        letter-spacing: 0;
      }

      .onSell {
        color: #7ed321;
      }

      .stopSell {
        color: #d0021b;
      }
    }
  }

  .mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .pop1-box {
      position: absolute;
      width: 480px;
      height: 560px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 540px;
        background: #fff;
        overflow: hidden;

        .item {
          width: 368px;
          height: 405px;
          margin-top: 8px;
          margin-left: 56px;

          .name-input,
          /deep/.ivu-input {
            width: 368px;
            height: 48px;
            // background: #f5f7fa;
            border-radius: 8px;
            padding-left: 24px;
          }

          /deep/ .ivu-select-selection {
            width: 368px;
            height: 48px;
            line-height: 48px;
            border-radius: 8px;
            padding-left: 24px;
            background: #ffffff;
            // border: 1px solid #DFDFDF;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            text-align: start;
          }

          /deep/ .ivu-select-placeholder,
          /deep/.ivu-select-selected-value {
            line-height: 48px;
            padding-left: 0;
            text-align: start;
          }

          .price-input {
            background: #ffffff;
            // border: 1px solid #dfdfdf;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            border-radius: 8px;
            width: 316px;
            height: 48px;
            // padding-left: 24px;
          }

          .unit {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #4a4a4a;
            letter-spacing: 0.3px;
            width: 42px;
            margin-left: 12px;
          }

          .title-box {
            margin: 14px 0 8px 0;

            span {
              color: #d0021b;
              margin-right: 5px;
            }

            /deep/ .ivu-radio-wrapper {
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0.3px;
            }

            /deep/.ivu-radio {
              margin-left: 30px;
            }

            .title {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #9097a9;
              letter-spacing: 0.3px;
              line-height: 22px;
            }
          }

          .remark,
          /deep/textarea.ivu-input {
            background: #ffffff;
            // border: 1px solid #dfdfdf;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            border-radius: 8px;
            width: 368px;
            height: 140px;
            padding: 14px;
            resize: none;
          }

          .remark {
            padding: 0;
          }
        }
      }

      .bottom {
        // transform: scaleY(-1);
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;

        .cancel {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.97) 0%, rgba(251, 251, 251, 0.98) 37%, #f5f5f5 100%);
          border: 1px solid #cacaca;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.97) 0%, rgba(251, 251, 251, 0.98) 37%, #e9e9e9 100%);
          }
        }

        .save {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          margin-left: 16px;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }
    }

    .pop3-box {
      position: absolute;
      width: 714px;
      height: 600px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 11;
      background: #ffffff;
      box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04), 0 20px 31px 0 rgba(0, 0, 0, 0.16);
      border-radius: 10px;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        background-color: #ffffff;
        width: 100%;
        height: 554px;
        border-radius: 10px;

        .item {
          width: 642px;
          margin: 0 auto;

          /deep/.ivu-table-tip {
            overflow-x: hidden;
          }

          .name {
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #9097a9;
            letter-spacing: 0.26px;
            margin: 20px 0 8px 14px;
            text-align: start;
          }

          .half {
            .half-input {
              width: 280px;
              height: 38px;
              background: #f5f7fa;
              border-radius: 8px;
              padding-left: 24px;
              font-family: PingFangSC-Semibold;
              font-size: 14px;
              color: #4a4a4a;
              letter-spacing: 0.26px;
            }
          }

          .long-input {
            background: #f5f7fa;
            border-radius: 8px;
            width: 642px;
            height: 38px;
            padding-left: 24px;
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            color: #4a4a4a;
            letter-spacing: 0.26px;
          }

          .split-line {
            margin: 28px 0;
            background-color: #ebedf3;
            height: 1px;
            border: none;
          }

          .filter {
            margin-bottom: 14px;

            .label {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              color: #616c84;
              margin: 0 10px 0 26px;

              &:first-child {
                margin-left: 0;
              }
            }

            /deep/.ivu-date-picker-focused input,
            /deep/.ivu-date-picker-focused input {
              font-size: 14px;
            }

            /deep/.ivu-select-selected-value,
            /deep/.ivu-select-item {
              text-align: start;
            }

            /deep/.ivu-input {
              font-size: 13px;
            }

            /deep/ .ivu-select-placeholder,
            /deep/.ivu-select-selected-value {
              line-height: 30px;
              padding-left: 12px;
              text-align: start;
            }

            .date-picker /deep/ .ivu-select-dropdown {
              left: 0 !important;
            }
          }

          .scroll-table {
            overflow-x: hidden;
            overflow-y: scroll;
            height: 230px;
            width: 659px;
          }

          /deep/ .ivu-table th {
            background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
            color: #fff;
          }

          /deep/ .ivu-table th:last-child {
            border-top-right-radius: 10px;
            background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
            color: #fff;
          }

          /deep/ .ivu-table th:first-child {
            // border-top-left-radius: 10px;
            background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
            color: #fff;
          }
        }
      }
    }
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  .table /deep/ .ivu-table th {
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  .table /deep/ .ivu-table th:first-child {
    // border-top-left-radius: 10px;
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  .table /deep/ .ivu-table th:last-child {
    border-top-right-radius: 10px;
    background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
    color: #fff;
  }

  .table /deep/ .ivu-table:before {
    background-color: transparent !important;
  }

  .table /deep/ .ivu-table:after {
    background-color: transparent !important;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: start;
    border-bottom: 1px solid #fafafa;
  }

  /deep/span.ivu-select-selected-value {
    border-bottom: none;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-radio-inner:after {
    background-color: #2c59c3;
  }

  /deep/.ivu-radio-checked .ivu-radio-inner {
    border-color: #2c59c3;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }

  input:disabled {
    border: 1px solid rgba(118, 118, 118, 0.3);
    box-shadow: none;
  }

  /deep/.ivu-table-tip {
    overflow-x: hidden;
  }

  /deep/.ivu-table-fixed-right {
    border-right: 1px solid #dcdee2;
  }
}
</style>
